<template>

  <div>

    <div class="px-4">
      <div class="d-flex py-3 border-bottom mb-1">
        <strong>{{ title }}</strong>
      </div>
    </div>

    <div class="d-flex justify-content-center" v-if="recipients === undefined">
      <small class="font-italic">Loading...</small>
    </div>

    <div class="d-flex justify-content-center" v-if="recipients?.length === 0">
      <small class="font-italic">Empty list</small>
    </div>

    <router-link
      v-for="recipient in recipients"
      :to="`/chatbox/${recipient.id}`"
      class="list-group-item list-group-item-action border-0"
      :class="{selected: activeRecipient?.id === recipient.id}"
      :key="`key-${recipient.id}`"
    >
      <div class="d-flex align-items-center">
        <img :src="recipient.profile_image ?? '/profile_images/default.png'" class="rounded-circle mr-1" :alt="recipient.first_name" width="40" height="40" />
        <div class="flex-grow-1 ml-3">
          {{ recipient.first_name }} {{ recipient.last_name }}
        </div>
      </div>
      <span v-if="recipient.connection_status === 0" class="pending-badge" title="Connection request pending">
        <i class="fas fa-clock"></i> Pending
      </span>
    </router-link>
  </div>

</template>

<script>
export default {
  props: {
    recipients: Array,
    activeRecipient: Object,
    title: String
  },
  computed: {
    profile() {
      return this.$store.state.profile;
    }
  },
  methods: {

  }
}
</script>

<style scoped>
.list-group-item.selected {
  z-index: 1;
  color: #495057;
  text-decoration: none;
  background-color: #f8f9fa;
}

.pending-badge {
  font-size: 0.68rem;
  font-weight: 600;
  color: #e0a320;
  background: rgba(224, 163, 32, 0.1);
  border: 1px solid rgba(224, 163, 32, 0.35);
  border-radius: 20px;
  padding: 2px 8px;
  white-space: nowrap;
}
</style>
